import { Injectable } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { Command, CommandBase, FilteredCommand } from '../../../core/model/command';
import { Observable, ObservableInput, of, pipe, switchMap } from 'rxjs';
import { propertyCommand } from '../../command/property.command';
import { NavigationService } from '../../../core/service/navigation.service';

@Injectable()
export class PropertyTaxRentalCommandHandler implements ICommandHandler {
  constructor(private _navigationService: NavigationService) {}

  canExecute(command: CommandBase): boolean {
    if (command.id !== propertyCommand.propertyTaxRental) {
      return false;
    }

    if (command instanceof FilteredCommand) {
      return true;
    }

    if (command instanceof Command) {
      return !!command.context?.id;
    }

    return false;
  }

  execute(command: CommandBase): Observable<boolean> {
    if (command instanceof FilteredCommand) {
      return pipe(switchMap(() => this.navigateToPropertyTaxRentalChanges(command.includedIds, command.excludedIds)))(of(true));
    }
    if (command instanceof Command) {
      return pipe(switchMap(() => this.navigateToPropertyTaxRentalChanges([command.context.id], [])))(of(true));
    }
    return of(false);
  }

  private navigateToPropertyTaxRentalChanges(includedIds: string[], excludedIds: string[]): ObservableInput<any> {
    return this._navigationService.navigate(['dh', 'my-property', 'property', 'property-tax-rental-changes'], {
      queryParams: { includedIds, excludedIds },
      replaceUrl: false,
    });
  }
}
